import * as common from "./common";
import * as center from "./center";
import * as theme from "./theme";
import * as board from "./board";
import * as form from "./form";
import * as user from "./user";
import * as roulette from "./roulette";
import * as history from "./history";
import * as hunt from "./hunt";
import * as clover from "./clover";
import * as gshop from "./gshop";
import * as shop from "./shop";
import * as me from "./me";

export const v1 = {
    ...board,
    ...center,
    ...common,
    ...form,
    ...theme,
    ...roulette,
    ...history,
    ...hunt,
    ...clover,
    ...user,
    ...gshop,
    ...shop,
    ...me
};